import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class RilevamentoScambiIntersezioneDoppiService {
    private baseUrl = `${environment.baseApiUrl}/rilevamento-scambi-intersezione-doppi`;

    private cache = new Map<any, Observable<any[]>>();

    constructor(private http: HttpClient) {}

    // LIST
    list(params?: { page?: number; size?: number; sort?: string }): Observable<any[]> {
        let httpParams = new HttpParams();
        if (params?.page != null) httpParams = httpParams.set('page', params.page);
        if (params?.size != null) httpParams = httpParams.set('size', params.size);
        if (params?.sort) httpParams = httpParams.set('sort', params.sort);

        return this.http.get<any[]>(this.baseUrl, {
            params: httpParams,
            withCredentials: true
        });
    }

    // GET by id
    get(id: number): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    // CREATE
    create(payload: Omit<any, 'id'>): Observable<any> {
        return this.http.post<any>(this.baseUrl, payload, { withCredentials: true });
    }

    // UPDATE
    update(entity: any): Observable<any> {
        return this.http.put<any>(`${this.baseUrl}/${entity.id}`, entity, { withCredentials: true });
    }

    // DELETE
    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    getOrFetch(deviatoioId: any, fetchFn: () => Observable<any[]>): Observable<any[]> {
        const cacheKey = deviatoioId?.id;

        if (!cacheKey) {
            return of([]);
        }

        if (!this.cache.has(cacheKey)) {
            this.cache.set(cacheKey, fetchFn().pipe(shareReplay(1)));
        }

        return this.cache.get(cacheKey)!;
    }
}
